import React from "react";
import { useEffect } from "react";
import { CustomTooltip } from "../../components/CustomTooltip";
import Pagination from "../Constant/Pagination";
import { Spinner } from "react-bootstrap";
import { Link, useSearchParams } from "react-router-dom";
import { UnitStatusBadge } from "../../components/CustomTooltip";
import { format } from "date-fns";
import { useSelector } from "react-redux";
import { FaInfo } from "react-icons/fa";

const AssetTableView = ({
  error,
  loading,
  data = [],
  param,
  setParam,
  total,
}) => {
  const userRole = useSelector((state) => state.auth.user.role);
  const [searchParams] = useSearchParams();
  
  useEffect(() => {
    const urlParams = Object.fromEntries(searchParams.entries());
    setParam(prev => ({
      ...prev,
      ...urlParams,
    }));
  }, [searchParams, setParam]);

  const handlePageChange = (page) => {
    setParam((prev) => ({
      ...prev,
      page: page.selected + 1,
    }));
  };

  return (
    <div className="mt-4">
      <div className="card overflow-hidden">
        {loading ? (
          <div className="text-center my-4">
            <Spinner animation="border" variant="primary" />
          </div>
        ) : error ? (
          <div className="text-center text-danger my-4">{error}</div>
        ) : data && data.length > 0 ? (
          <div className="table-responsive">
            <table className="table fs-6 mb-0 align-middle">
              <thead className="table-light custom-thead">
                <tr>
                  <th>Asset Number</th>
                  <th>RFID Tag</th>
                  <th>Asset Name</th>
                  {userRole == "ADMIN" && <th>Location</th>}
                  <th>Cost (₹)</th>
                  <th>Purchase Date</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {data.map((asset, index) => (
                  <tr key={index}>
                    <td>
                      <Link
                        to={`/asset/${asset?.id}/basic-details`}
                        className="fw-bold text-primary"
                      >
                        {asset?.asset_number || "-"}
                      </Link>
                    </td>
                    <td>{asset?.rfid_tag_id || "-"}</td>
                    <td>
                      <div className="d-flex align-items-center gap-1 cursor-pointer">
                        <span>{asset?.name || "-"}</span>
                        <CustomTooltip
                          title={
                            <div>
                              <div>
                                <strong>Category:</strong>{" "}
                                {asset?.category || "-"}
                              </div>
                              <div>
                                <strong>Sub-category:</strong>{" "}
                                {asset?.sub_category || "-"}
                              </div>
                              <div>
                                <strong>Model No.:</strong>{" "}
                                {asset?.model_number || "-"}
                              </div>
                              <div>
                                <strong>Brand:</strong> {asset?.brand || "-"}
                              </div>
                            </div>
                          }
                          placement="right"
                        >
                          <span
                            className="rounded-1 ms-1 btn btn-sm btn-outline-light"
                            style={{
                              cursor: "pointer",
                              padding: "0.2rem 0.2rem",
                            }}
                          >
                            <FaInfo size={9} className="text-dark" />
                          </span>
                        </CustomTooltip>
                      </div>
                    </td>
                    {userRole == "ADMIN" && (
                      <td>{asset?.current_location || "-"}</td>
                    )}
                    <td>{`₹${asset?.purchase_cost}` || "-"}</td>
                    <td>
                      {asset?.purchase_date
                        ? format(new Date(asset.purchase_date), "dd MMM yyyy")
                        : "-"}
                    </td>
                    <td>
                      <UnitStatusBadge status={asset?.status} />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="text-center my-4">
            <span>No data found</span>
          </div>
        )}

        {!loading && data?.length > 0 && (
          <div className="p-4">
            <Pagination
              currentPage={param.page}
              recordsPage={param.page_size}
              dataLength={total}
              handlePagination={handlePageChange}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default AssetTableView;